import { useQuery } from "@tanstack/react-query";

import { withJWTClient } from "./connectClient";

// The login hop on the host that holds the session, local dev included.
export const docsAccessEndpoint = (): string =>
  `${(import.meta.env.VITE_JWT_TOKEN_PATH as string).replace(/\/+$/, "")}/helpkit`;

// The same hop with the refresh cookie, for opening the docs in a new tab.
export const docsLoginUrl = (): string =>
  `${docsAccessEndpoint()}?returnTo=%2F`;

const HOUR_MS = 60 * 60 * 1000;

export function useDocsAccessUrl(userSub: string | undefined) {
  return useQuery({
    // Per user, so a session change never replays another user's URL.
    queryKey: ["docs-access", userSub],
    queryFn: async () => {
      // ?json: Bearer only, never the refresh cookie (helpkitRoute.ts).
      const { data } = await withJWTClient((client) =>
        client.get<{ url?: unknown }>(docsAccessEndpoint(), {
          params: { json: 1 },
        }),
      );
      if (typeof data?.url !== "string" || !data.url)
        throw new Error("Docs access response has no url");
      return data.url;
    },
    enabled: userSub !== undefined,
    // Well inside the token's 24h, so re-entering Docs reuses it.
    staleTime: HOUR_MS,
    gcTime: HOUR_MS,
    // A refetch would reset the iframe to the help center home.
    refetchOnWindowFocus: false,
    refetchOnReconnect: false,
    retry: false,
  });
}
